import { useEffect } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { LEGAL, LEGAL_NOTE } from "@/config/legal";

export const LegalLayout = ({ title, children, testId }) => {
  useEffect(() => { window.scrollTo(0, 0); document.title = `${title} | Progetto HOSPITALITY`; }, [title]);
  return (
    <>
      <Header />
      <main className="bg-warm pt-28 lg:pt-36 pb-20" data-testid={testId}>
        <article className="container-ph max-w-3xl">
          <span className="gold-line mb-5" />
          <h1 className="h-section">{title}</h1>
          <p className="mt-3 text-xs text-ink/50">Ultimo aggiornamento: {LEGAL.ultimoAggiornamento}</p>
          <p className="mt-5 border-l-2 border-bronze/60 pl-4 text-xs text-ink/55 italic" data-testid="legal-note">{LEGAL_NOTE}</p>
          <div className="legal-body mt-10">{children}</div>
        </article>
      </main>
      <Footer />
      <WhatsAppFloat />
    </>
  );
};

export const LegalSection = ({ title, children }) => (
  <section className="mt-10">
    <h2 className="font-serif text-2xl sm:text-3xl text-forest">{title}</h2>
    <div className="mt-4 space-y-3 text-sm sm:text-base text-ink/80 leading-relaxed">{children}</div>
  </section>
);
